import React from 'react'
import image from '../../../../assets/homepage_img1.png';
const LowerTimerBanner = () => {
    return (
        <>
            <section className="over-hid">
                <div className="container">
                    <div className="cstm-wdth d-flex justify-content-between">
                        <div className="mubarak-bx d-flex align-items-center justify-content-between">
                            <div className="mubarak-txt">
                                <h3>Ramadan Mubarak 2022</h3>
                                <p>Time: Monday, October 11 to Friday October 15</p>
                                <div className="d-flex cd100 mt-4">
                                    <div className="count-bx2 text-center mr-4">
                                        <h3 className="number-bx2 days">10</h3>
                                        <span className="s1-txt1">Days</span>
                                    </div>
                                    <div className="count-bx2 text-center mr-4">
                                        <h3 className="number-bx2 hours">11</h3>
                                        <span className="s1-txt1">Hours</span>
                                    </div>
                                    <div className="count-bx2 text-center mr-4">
                                        <h3 className="number-bx2 minutes">59</h3>
                                        <span className="s1-txt1">Minutes</span>
                                    </div>
                                    <div className="count-bx2 text-center">
                                        <h3 className="number-bx2 seconds">36</h3>
                                        <span className="s1-txt1">Seconds</span>
                                    </div>
                                </div>
                                <a href="#" className="btn-buy">
                                    Read More
                                </a>
                            </div>
                            <div className="mubarak-img">
                                <img className="img-fluid" src={image} alt="" />
                            </div>
                        </div>
                        <div className="ceremony-bx">
                            <div>
                                <h3>Intel core i9</h3>
                                <h2>
                                    Opening Cerimony <span>Special Discount</span>
                                </h2>
                                <p>
                                    Join with us on: <span>Thursday, 21 December 2021</span>
                                </p>
                                <p>
                                    Venue: <span>Multiplan Centre Conference Centre.</span>
                                </p>
                                <a href="#" className="btn-buy">
                                    Book Now
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default LowerTimerBanner;